<template>
    <Dialog v-model:open="opnened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("event_types.create_event_type.title") }}</DialogTitle
                >
                <!-- <DialogDescription>
                    Make changes to your profile here. Click save when you're
                    done.
                </DialogDescription> -->
            </DialogHeader>

            <div class="sm:flex sm:items-start">
                <div class="mt-3 w-full text-center sm:mt-0 sm:text-left">
                    <div class="mt-2">
                        <div v-if="teams.length > 1" class="mt-4">
                            <label
                                for="teamName"
                                class="block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.team_label",
                                    )
                                }}
                            </label>
                            <div class="mt-1 flex w-full justify-end">
                                <select
                                    id="teamName"
                                    v-model="teamId"
                                    class="focus-visible:ring-iron-950 dark:bg-iron-950 dark:ring-offset-iron-950 flex h-10 w-full rounded-lg border border-iron-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-iron-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus-visible:ring-iron-300"
                                >
                                    <option
                                        v-for="team in teams"
                                        :key="team.id"
                                        :value="team.id"
                                    >
                                        {{
                                            team.personal_team
                                                ? $t("event_types.personal")
                                                : team.name
                                        }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="mt-4">
                            <label
                                for="email"
                                class="block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.name_label",
                                    )
                                }}
                            </label>
                            <div class="mt-1 w-full">
                                <Input
                                    v-model="eventTypeName"
                                    type="text"
                                    name="event-type-name"
                                    :placeholder="
                                        $t(
                                            'event_types.create_event_type.name_placeholder',
                                        )
                                    "
                                />
                            </div>
                        </div>
                        <div v-if="integrations.length > 0">
                            <label
                                for="email"
                                class="mt-4 block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.choose_integration",
                                    )
                                }}

                                <p class="mt-2 font-normal text-iron-700">
                                    {{
                                        $t(
                                            "event_types.create_event_type.choose_integration_description",
                                        )
                                    }}
                                </p>
                            </label>
                            <fieldset class="mt-4">
                                <legend class="sr-only">
                                    Event Type Integrations
                                </legend>
                                <div class="-space-y-px rounded-lg bg-white">
                                    <!-- Checked: "bg-z-primary-50 border-z-primary-200 z-10", Not Checked: "border-iron-200" -->
                                    <div
                                        v-for="(integration, i) in integrations"
                                        :key="i"
                                        @click="selectIntegration(integration)"
                                    >
                                        <label
                                            :data-cy="'integration-' + i"
                                            class="relative flex cursor-pointer items-center p-4 shadow-sm ring-1 ring-iron-200 transition-all duration-100 ease-out hover:shadow-lg hover:ring-2 hover:ring-z-primary-400"
                                            :class="{
                                                'rounded-md':
                                                    integrations.length === 1,
                                                'rounded-bl-md rounded-br-md':
                                                    integrations.length ===
                                                    i + 1,
                                                'rounded-tl-md rounded-tr-md':
                                                    i === 0,
                                                'bg-z-primary-50 ring-2 ring-z-primary-400':
                                                    selectedIntegration?.id ===
                                                    integration.id,
                                            }"
                                        >
                                            <input
                                                type="radio"
                                                :checked="
                                                    selectedIntegration?.id ===
                                                    integration.id
                                                "
                                                name="integration"
                                                class="mt-0.5 h-4 w-4 cursor-pointer border-iron-300 text-z-primary-600 focus:ring-z-primary-500"
                                                aria-labelledby="privacy-setting-0-label"
                                                aria-describedby="privacy-setting-0-description"
                                            />
                                            <div
                                                class="lex ml-3 w-full flex-col"
                                            >
                                                <!-- Checked: "text-z-primary-900", Not Checked: "text-iron-900" -->
                                                <Integration
                                                    :integration="integration"
                                                    :deletable="false"
                                                />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div v-if="integrationCalendars.length > 0">
                            <label
                                for="email"
                                class="mt-4 block text-sm font-medium text-iron-700"
                            >
                                {{
                                    $t(
                                        "event_types.create_event_type.choose_calendar",
                                    )
                                }}
                            </label>
                            <fieldset class="mt-1">
                                <legend class="sr-only">
                                    EventTypes for integration
                                </legend>
                                <div
                                    class="max-h-[250px] -space-y-px overflow-y-scroll rounded-md bg-white"
                                >
                                    <!-- Checked: "bg-z-primary-50 border-z-primary-200 z-10", Not Checked: "border-iron-200" -->

                                    <RadioGroup v-model="selectedCalendar">
                                        <div
                                            class="relative -space-y-px rounded-md bg-white"
                                        >
                                            <RadioGroupOption
                                                v-for="(
                                                    eventType, eventTypeIdx
                                                ) in integrationCalendars"
                                                :key="eventType.id"
                                                v-slot="{ checked, active }"
                                                as="template"
                                                :value="eventType.id"
                                            >
                                                <div
                                                    :class="[
                                                        eventTypeIdx === 0
                                                            ? 'rounded-tl-md rounded-tr-md'
                                                            : '',
                                                        eventTypeIdx + 1 ===
                                                        integrationCalendars.length
                                                            ? 'rounded-bl-md rounded-br-md'
                                                            : '',
                                                        checked
                                                            ? 'z-10 border-z-primary-200 bg-z-primary-50'
                                                            : 'border-iron-200',
                                                        'relative flex cursor-pointer flex-col border p-4 focus:outline-none md:grid md:pl-4 md:pr-6',
                                                    ]"
                                                >
                                                    <div
                                                        class="flex items-center text-sm"
                                                    >
                                                        <div
                                                            :class="[
                                                                checked
                                                                    ? 'border-transparent bg-z-primary-600'
                                                                    : 'border-iron-300 bg-white',
                                                                active
                                                                    ? 'ring-2 ring-z-primary-500 ring-offset-2'
                                                                    : '',
                                                                'flex h-4 w-4 items-center justify-center rounded-full border',
                                                            ]"
                                                            aria-hidden="true"
                                                        >
                                                            <div
                                                                class="h-1.5 w-1.5 rounded-full bg-white"
                                                            />
                                                        </div>
                                                        <RadioGroupLabel
                                                            as="span"
                                                            :class="[
                                                                checked
                                                                    ? 'text-z-primary-900'
                                                                    : 'text-iron-900',
                                                                'ml-3 truncate font-medium',
                                                            ]"
                                                            >{{
                                                                eventType.name
                                                            }}</RadioGroupLabel
                                                        >
                                                    </div>
                                                </div>
                                            </RadioGroupOption>
                                        </div>
                                    </RadioGroup>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>
            </div>

            <DialogFooter>
                <div
                    class="inline-block transform overflow-hidden rounded-lg text-left align-bottom transition-all sm:w-full sm:max-w-lg sm:align-middle"
                >
                    <div
                        class="gap-3 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6"
                    >
                        <Button @click="createEventType">{{
                            $t("event_types.create_event_type.new_event_type")
                        }}</Button>

                        <Button variant="outline" @click="closeModal">
                            {{ $t("cancel") }}</Button
                        >
                    </div>
                </div>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import Integration from "../../Integrations/components/GoogleIntegration.vue";
import { router, usePage } from "@inertiajs/vue3";
import axios from "axios";
import { RadioGroup, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";
import { computed, ref } from "vue";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import route from "ziggy-js";

const props = defineProps<{
    integrations: any[];
}>();

const page = usePage();

const selectedIntegration = ref(undefined);
const eventTypeName = ref("");
const calendarIntegrationId = ref(undefined);
const integrationCalendars = ref([]);
const selectedCalendar = ref(null);
const opnened = ref(false);
// @ts-expect-error
const teamId = ref<any>(page.props.personalTeam.id);

function closeModal() {
    opnened.value = false;
}

async function getCalendarsForIntegration(integrationId: number) {
    try {
        const res = await axios.get(
            route("app.integrations.calendars.index", {
                integration: integrationId,
            }),
        );
        integrationCalendars.value = res.data.data;

        // @ts-expect-error
        selectedCalendar.value = integrationCalendars.value[0].id;
    } catch (err) {
        console.error(err);
    }
}

async function createEventType() {
    try {
        const calendar = integrationCalendars.value.find(
            (c) => c.id === selectedCalendar.value,
        );

        const data = {
            name: eventTypeName.value,
            enabled: true,
            description: "testdfsfs",
        };

        if (selectedIntegration.value !== undefined) {
            data.integration_id = selectedIntegration.value.id;
            data.integration_calendar_id = calendar.id;
            data.integration_calendar_name = calendar.name;
            data.integration_calendar_default = calendar.default;
        }

        data.team_id = teamId.value;

        await router.post("/event-types", data, {
            onSuccess: () => {
                closeModal();
            },
            preserveScroll: true,
        });
    } catch (err) {
        console.error(err);
    }
}

async function selectIntegration(integration: any) {
    if (selectedIntegration.value?.id === integration.id) {
        selectedIntegration.value = undefined;
        calendarIntegrationId.value = undefined;
        integrationCalendars.value = [];
        selectedCalendar.value = null;
        return;
    }

    await getCalendarsForIntegration(integration.id);
    selectedIntegration.value = integration;
    calendarIntegrationId.value = integration.id;
}

const teams = computed(() => {
    return page.props.allTeams;
});
</script>

<style></style>
